import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const AppointmentService = {};

AppointmentService.createAppointment = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/RendezVous",
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

AppointmentService.UpdateAppointment = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/RendezVous/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

AppointmentService.FulfillAppointment = function (id, data) {
  return axiosPrivate({
    method: "post",
    url: `/RendezVous/fulfill/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

AppointmentService.getAppointments = function (queryString) {
  return axiosPrivate({
    method: "get",
    url: `/RendezVous?${queryString}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

AppointmentService.getOneAppointment = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/RendezVous/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

AppointmentService.deleteAppointment = function (id) {
  return axiosPrivate({
    method: "delete",
    url: `/RendezVous/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};
AppointmentService.validateAppointment = function (id) {
  return axiosPrivate({
    method: "put",
    url: `/RendezVous/${id}/validate`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

export default AppointmentService;